// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__lZmSk","imageUploader":"EGiftCard_imageUploader__2vlv0"};